import React from "react";
import "./styles.scss";
import {
  Autocomplete,
  Box,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import {
  FILTER_BY_PLAN_STATUS,
  FILTER_BY_PLAN_TYPE,
  FILTER_BY_PROFILE_STATUS,
  FILTER_BY_TAG,
} from "../../../constants/filterConst";
import FilterDialog from "../filter";
import FilterItem from "../filterItem";

function ClientFilter(props) {
  const {
    visible,
    hideFilter,
    changeSelectorValue,
    apply,
    cancel,
    filterProps,
    statuses,
    types,
    tags = [],
  } = props;
  const [tagSelection, setTagSelection] = React.useState([]);
  const [tagMatch, setTagMatch] = React.useState("OR");

  const handleChangeSelectorValue = (filter, filterBy) =>
    changeSelectorValue(filter, filterBy);

  React.useEffect(() => {
    const tagFilter = filterProps.filterValue?.find(
      (f) => f.filterBy === FILTER_BY_TAG
    );
    if (tagFilter) {
      if (Array.isArray(tagFilter.filter)) {
        setTagSelection(tagFilter.filter);
      } else if (
        tagFilter.filter &&
        typeof tagFilter.filter === "object" &&
        Array.isArray(tagFilter.filter.ids)
      ) {
        setTagSelection(tagFilter.filter.ids);
        setTagMatch(tagFilter.filter.match || "OR");
      } else if (tagFilter.filter) {
        setTagSelection([tagFilter.filter]);
      }
    }
  }, [filterProps.filterValue]);

  const tagOptions = React.useMemo(() => {
    const missing = tagSelection
      .filter((id) => !tags.some((t) => t.id === id))
      .map((id) => ({ id, name: id }));
    return [...tags, ...missing];
  }, [tags, tagSelection]);

  const handleTagChange = (_event, values) => {
    const ids = values.map((v) => v.id);
    setTagSelection(ids);
    changeSelectorValue({ ids, match: tagMatch }, FILTER_BY_TAG);
  };

  const handleTagMatchChange = (_event, value) => {
    if (!value) return;
    setTagMatch(value);
    changeSelectorValue({ ids: tagSelection, match: value }, FILTER_BY_TAG);
  };

  return (
    <FilterDialog
      visible={visible}
      hideDialog={hideFilter}
      apply={apply}
      cancel={cancel}
      body={
        <>
          <FilterItem
            filterBy={FILTER_BY_PLAN_STATUS}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={statuses.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
          <FilterItem
            filterBy={FILTER_BY_PLAN_TYPE}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={types.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
          <FilterItem
            filterBy={FILTER_BY_PROFILE_STATUS}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={["ACTIVE", "BLOCKED", "DELETED"].map(
              (item, index) => ({
                id: index,
                name: item,
              })
            )}
            filterProps={filterProps}
          />
          {tags.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 2.5,
                px: 1,
              }}
            >
              <Typography variant="body2" sx={{ pl: 0.5, fontWeight: 600 }}>
                Tags
              </Typography>
              <Autocomplete
                multiple={true}
                options={tagOptions}
                filterSelectedOptions={true}
                getOptionLabel={(option) => option.name || option.id}
                value={tagOptions.filter((t) => tagSelection.includes(t.id))}
                onChange={handleTagChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Select tags"
                    InputProps={{
                      ...params.InputProps,
                      sx: { borderRadius: 1.5, bgcolor: "#fff" },
                    }}
                  />
                )}
              />
              {tagSelection.length >= 2 && (
                <ToggleButtonGroup
                  color="primary"
                  value={tagMatch}
                  exclusive={true}
                  onChange={handleTagMatchChange}
                  size="small"
                  sx={{ alignSelf: "flex-start" }}
                >
                  <ToggleButton value="OR">Match any</ToggleButton>
                  <ToggleButton value="AND">Match all</ToggleButton>
                </ToggleButtonGroup>
              )}
            </Box>
          )}
        </>
      }
    />
  );
}

export default ClientFilter;
